<script lang="ts">
  import { fixedNews } from "../../store"  
  import PreviewCard from "../../../../custom/PreviewCard/PreviewCard.svelte"
</script>

{#each $fixedNews as news}
  <PreviewCard publication={news} fixPublication />
{/each}